module.exports = __webpack_public_path__ + "static/interaction-1-1-d764c9921ea95bff423aebf42c1d4846.png";